import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings, User } from 'oidc-client';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

// Stolen from https://bitbucket.org/DevelopmentOps/security-gateway-admin-ui/
export function getClientSettings(originUrl: string, authUrl: string, clientId: string, apiUrl: string): UserManagerSettings {
    return {
        authority: authUrl,
        client_id: clientId,
        redirect_uri: originUrl + '/login',
        silent_redirect_uri: originUrl + '/login',
        post_logout_redirect_uri: originUrl + '/home',
        response_type: 'id_token token',
        scope: 'openid profile email offline_access ' + apiUrl,
        filterProtocolClaims: true,
        loadUserInfo: false,
        revokeAccessTokenOnSignout: true,
        popupWindowTarget: '_top',
        extraQueryParams: {response_mode: 'fragment'}
    };
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
    private manager = new UserManager(getClientSettings(
        environment.BASE_URL, environment.AUTH_URL, environment.CLIENT_ID, environment.API_URL));
    private user: User = null;

    constructor(private router: Router) {
        this.manager.getUser().then(user => {
            this.user = user;
        });
    }

    isLoggedIn(): boolean {

        return this.user != null && !this.user.expired;
    }

    getUser(): any {
        return this.user;
    }

    getClaims(): any {
        return this.user.profile;
    }

    getAuthorizationHeaderValue(): string {
        if (this.isLoggedIn()) {
            return `${this.user.token_type} ${this.user.access_token}`;
        } else {
            return '';
        }
    }

    startAuthentication(): Promise<User> {
        return this.manager.signinPopup();
    }

    async completeAuthentication(): Promise<void> {
        const user = this.manager.signinRedirectCallback().then(inUser => {
            this.user = inUser;
            sessionStorage.setItem('USER_NAME', inUser.profile.name);
        })
        .catch(error => {
            console.log('No state in response');
        });
    }

    endSession(): Promise<void> {
        sessionStorage.clear();
        return this.manager.signoutPopup();
    }
}
